import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { SimpleErrorPage } from '@ynap/error-page'
import Spinner from '@ynap/spinner'

const bem = new BEMHelper('Buyapowa')

export const Buyapowa = ({ loading, title, messages, rootElem, errorElem, country, language, deviceType }) => {
    return (
        <div>
            <h2 className={bem('title')}>{title}</h2>
            <div id={errorElem} className={bem('error')} style={{ display: 'none' }}>
                <SimpleErrorPage
                    displayMessage={messages.referrals.error()}
                    actionLabel={messages.referrals.errorAction()}
                    action={() => window.history.back()}
                    language={language}
                    country={country}
                    deviceType={deviceType}
                />
            </div>
            <div id={rootElem} />
            {loading && (
                <div className={bem('spinner')}>
                    <Spinner />
                </div>
            )}
        </div>
    )
}
